(ns frontend.ui.component.lp-portal.report.body.lifeline.holding.controller 
  (:require
   [frontend.ui.component.lp-portal.report.body.invest-europe.holding.controller :refer [invest-europe-editable-data->raw-data
                                                                                         invest-europe-table-raw-data->editable-data]]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]))

(defn ->holding-ui-data
  [{:keys [report-data dynamic-data] :as props}]
  {:holding-name           (get-in report-data [:holding-name])
   :cross-fund-investment? (get-in report-data [:cross-fund-investment?])
   :reference-date         (get-in report-data [:reference-date])
   :reporting-period       (get-in report-data [:reporting-period])
   :report-id              (:report-id props)
   :logo-image   (report-ctl/image-content
                    props
                    :logo-image-footnotes
                    (:logo-image dynamic-data))
   :description      (report-ctl/rich-content
                      props
                      :description-text)
   :significant-events      (report-ctl/rich-content
                             props
                             :signifigant-events-text)
   :company-information (->> (report-ctl/with-footnote
                               props
                               :company-information-footnotes
                               (:company-information report-data))
                             (report-ctl/with-editable-tables
                               (merge {:fixed-columns? true
                                       :fixed-labels? true} props) :company-information
                               invest-europe-table-raw-data->editable-data
                               invest-europe-editable-data->raw-data))
   :investment-information (->> (report-ctl/with-footnote
                                  props
                                  :investment-information-footnotes
                                  (:investment-information report-data))
                                (report-ctl/with-editable-tables
                                  (merge {:fixed-columns? true
                                          :fixed-labels? true} props)
                                  :investment-information
                                  invest-europe-table-raw-data->editable-data
                                  invest-europe-editable-data->raw-data))
   :financials-table (->> (report-ctl/with-footnote
                            props
                            :financials-table-footnotes
                            (:financials-table report-data))
                          (report-ctl/with-editable-tables props
                            :financials-table
                            invest-europe-table-raw-data->editable-data
                            invest-europe-editable-data->raw-data))
   :latest-transactions (report-ctl/with-footnote
                          props
                          :latest-transactions-footnotes
                          (:latest-transactions report-data))})
